// Mirrors the backend HISTORY_ACTOR / ENTITY_TYPE enum written to every polymorphic `*_type`
// column (history rows, clinical_note_addendum.created_by_type, …). Admin and user ids collide
// numerically, so an id is only meaningful alongside its type.
export const HISTORY_ACTOR = {
  ADMIN: 0,
  USER: 1,
  AUTOMATION: 2
};

// Mirrors backend adminActorMask.MYRIAD_STAFF_LABEL exactly, casing included.
// ExpandableToolbar/lib/helpers.js keeps its own copy; fold it in with the activity-log work.
export const MYRIAD_STAFF_LABEL = 'Myriad staff';
